<template lang="pug">
  v-row(style="background: white;")
    v-col.mb-10(md="8" offset-md="2")
      credit-card-form

</template>

<script>
  export default {
    name: 'NewCard',

    components: {
      CreditCardForm: () => import('@/views/pages/components/CreditCardForm'),
    },

    data: () => ({
    }),
  }
</script>
